import { render, staticRenderFns } from "./ClientBackground.vue?vue&type=template&id=7d4487f2&scoped=true"
import script from "./ClientBackground.vue?vue&type=script&lang=js"
export * from "./ClientBackground.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=7d4487f2&prod&scoped=true&lang=css&external"
import style1 from "./ClientBackground.vue?vue&type=style&index=1&id=7d4487f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4487f2",
  null
  
)

export default component.exports